import { normalizeToUTC } from "@revbox/helpers-fe";
import axiosInstance from "../../axios/instance";
import { getToken } from "../../helpers/get-token";

const StatusMap = ["Live", "Draft", "All"];

async function getPeriodInventoryInsightsCampaignsAndPlaceholders(
    currentPeriod,
    previousPeriod,
    status = 2,
    search = "",
    currentPage = 1,
    inventoryId,
    sortingParams,
) {
    try {
        const token = getToken();
        axiosInstance.defaults.headers.common['authorization'] = token;

        let url = `${process.env.REACT_APP_HUB_URL}/api/analytics/inventory/insights/period/campaigns-and-placeholders?page=${currentPage}`;

        if (search) {
            url += `&search=${encodeURIComponent(search)}`;
        }

        if (sortingParams?.columnName) {
            url += `&column_name=${sortingParams.columnName}`;
        }
        if (sortingParams?.sortOrder) {
            url += `&column_order=${sortingParams.sortOrder}`;
        }
        console.log(status,StatusMap[status]);
        const response = await axiosInstance.post(url, {
            current_period: [normalizeToUTC(currentPeriod[0]).getTime(), normalizeToUTC(currentPeriod[1]).getTime()],
            previous_period: [normalizeToUTC(previousPeriod[0]).getTime(), normalizeToUTC(previousPeriod[1]).getTime()],
            inventory_id: inventoryId,
            status: StatusMap[status]
        });
        return response?.data;
    } catch (error) {
        console.log(error);
    }
}

export default getPeriodInventoryInsightsCampaignsAndPlaceholders;
